import { Button } from 'components/Button';
import styled from 'styled-components';

const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  margin-left: 15rem;
`;

const ButtonAdd = styled(Button)`
  width: 16rem;
`;

const ButtonRemove = styled(Button)`
  margin-left: auto;
`;

export { SelectContainer, ButtonAdd, ButtonRemove };
